import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { isProd, NodeEnv } from '@/ui/helpers/systemHelper';
import { router } from '@/ui/routes';

export const initialize = () => Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
  ],
  environment: process.env.NODE_ENV || NodeEnv.production,
  tracesSampleRate: isProd ? 0.5 : 0.1,
  ignoreErrors: [
    'Non-Error exception captured',
    'Non-Error promise rejection captured',
  ],
});
